import { EmailShareButton } from 'react-share'
import React, { Component } from 'react'
import { RaisedButton } from 'material-ui'
import muiThemeable from 'material-ui/styles/muiThemeable'

import { trackEvent } from '../../app/ga'
import TextField from '../../components/TextField'
import Msg from '../../components/Msg'
import { SafeStorage } from '../../common/storageUtil'

const LS_KEY = 'presentation_notes_'

const styles = {
  shareButtonMail: {
    width: 200,
    display: 'inline-block',
  },
}

class PresentationNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // presentation should be "constant" per instance
      notes: SafeStorage.get(LS_KEY + props.presentation.title) || '',
      // initial readOnly=true is IOS safari workaround
      // test case: click on presentation in program -> keyboard should NOT open
      readOnly: true,
    }
  }

  handleChangeNotes = event => {
    this.trackTyping()
    const notes = event.target.value
    SafeStorage.set(LS_KEY + this.props.presentation.title, notes)
    this.setState({
      notes,
    })
  }

  trackTyping = () => {
    if (!this._typingGaSent) {
      trackEvent('notes', 'typing', this.props.presentation.title)
      this._typingGaSent = true
    }
  }

  trackEmailShare = () => {
    trackEvent('notes', 'shareEmail', this.props.presentation.title)
  }

  componentDidMount() {
    setTimeout(() => this.setState({ readOnly: false }), 100)
  }

  render() {
    const { appTitle, presentation, muiTheme } = this.props
    const { palette: { alternateTextColor } } = muiTheme
    // HACK!? maybe share button somehow override the styles?
    const primaryButtonStyle = { color: alternateTextColor }
    const { title, presenter } = presentation
    return (
      <div>
        <div>
          <h2>
            <Msg id="PresentationNotes.title" />
          </h2>
          <TextField
            hintText={<Msg id="PresentationNotes.hint" />}
            multiLine={true}
            rows={5}
            fullWidth={true}
            onChange={this.handleChangeNotes}
            value={this.state.notes}
            readOnly={this.state.readOnly}
          />
        </div>
        <div style={{ textAlign: 'right' }}>
          <EmailShareButton
            url={window.location.href}
            subject={appTitle + ' | ' + title}
            body={this.state.notes}
            style={styles.shareButtonMail}
          >
            <RaisedButton
              primary
              fullWidth
              buttonStyle={primaryButtonStyle}
              onClick={this.trackEmailShare}
            >
              <Msg id="PresentationNotes.shareMail" />
            </RaisedButton>
          </EmailShareButton>
        </div>
      </div>
    )
  }
}

export default muiThemeable()(PresentationNotes)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationNotes.js